import * as React from 'react'
import { LoadingContainer, LoadingWrapper } from './styles'

type ILoading = {
  position?: string
  loading?: boolean
  iconwidth?: string
  text?: string
  children?: React.ReactNode
}

export default function Loading({
  position,
  loading,
  iconwidth,
  text,
  children,
}: ILoading) {
  if (!children) {
    return (
      <LoadingWrapper
        position={position || ''}
        iconwidth={iconwidth ? iconwidth : ''}
      >
        {text && (
          <p
            className="loading-text"
            style={{ marginTop: '-60px', marginBottom: '6px' }}
          >
            {text}
          </p>
        )}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <circle
            cx="50"
            cy="50"
            fill="none"
            stroke="#e15b64"
            strokeWidth="5"
            r="35"
            strokeDasharray="164.93361431346415 56.97787143782138"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              repeatCount="indefinite"
              dur="1s"
              values="0 50 50;360 50 50"
              keyTimes="0;1"
            ></animateTransform>
          </circle>
        </svg>
      </LoadingWrapper>
    )
  }

  return (
    <LoadingContainer>
      {loading && (
        <LoadingWrapper
          position={position || ''}
          iconwidth={iconwidth ? iconwidth : ''}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
          >
            <circle
              cx="50"
              cy="50"
              fill="none"
              stroke="#e15b64"
              strokeWidth="5"
              r="35"
              strokeDasharray="164.93361431346415 56.97787143782138"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                repeatCount="indefinite"
                dur="1s"
                values="0 50 50;360 50 50"
                keyTimes="0;1"
              ></animateTransform>
            </circle>
          </svg>
        </LoadingWrapper>
      )}
      {children}
    </LoadingContainer>
  )
}
